import { useState, useEffect } from "react";

// @mui material components
import VerifiedIcon from "@mui/icons-material/Verified";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { IoMenu } from "react-icons/io5";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiProgress from "components/VuiProgress";
import VuiOpenLink from "components/VuiOpenLink";
import VuiLoading from "components/VuiLoading";
import VuiLabel from "components/VuiLabel";

import moment from "moment";
import api from "services/api";
import useWindowDimensions from "hooks/useWindowDimensions";

import VuiInfoItemClockTime from "components/VuiInfoItemClockTime";

import colors from "assets/theme/base/colors";

// Function randomInt(min, max)
// min and max included
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function ClockTime() {
  const { height, width } = useWindowDimensions();
  const [loading, setLoading] = useState(true);
  const [refreshInterval, setRefreshInterval] = useState(60000);
  const [countOffLines, setCountOfflines] = useState(0);
  const [countOnLines, setCountOnlines] = useState(0);
  const [countAllUnits, setCountAllUnits] = useState(0);

  async function loadLinks() {
    setLoading(true);
    const res = await api.get("clocktime");
    const data = [];
    res.data.map((x) => {
      if (x.enabled) {
        data.push({
          ...x,
          updatedAt: x.status
            ? moment().format("DD/MM/YYYY HH:mm:ss")
            : moment(x.updatedAt).format("DD/MM/YYYY HH:mm:ss"),
        });
      }
    });

    const offlineLinks = data.filter((x) => !x.status).length;
    const onlineLinks = data.filter((x) => x.status).length;

    setCountOfflines(offlineLinks);
    setCountOnlines(onlineLinks);
    setCountAllUnits(data.length);

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }

  useEffect(() => {
    loadLinks();
  }, [false]);

  useEffect(() => {
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(loadLinks, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  return (
    <>
      {loading ? (
        <VuiLoading height={110} />
      ) : (
        <div>
          <VuiBox display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
            <IoMenu size={32} style={{ marginRight: 10 }} />
            <VuiLabel
              title={`Relógios de Ponto`}
              colorTitle="warning"
              fontWeight="bold"
              sizeTitle={24}
            />
          </VuiBox>

          <div
            style={{
              display: "grid",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginBottom: 20,
            }}
          >
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
              {countOffLines > 0 ? (
                <>
                  <div style={{ textAlign: "right", color: colors.warning.main }}>
                    {countOffLines > 0 && countOffLines < countAllUnits
                      ? ((countOffLines / countAllUnits) * 100).toFixed(2)
                      : 100}
                    %
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      textAlign: "right",
                      color: colors.error.main,
                    }}
                  >
                    Offline
                  </div>
                </>
              ) : (
                <>
                  <div style={{ textAlign: "right", color: colors.success.focus }}>100%</div>
                  <div
                    style={{ fontWeight: "bold", textAlign: "right", color: colors.success.main }}
                  >
                    Online
                  </div>
                </>
              )}
            </div>
            <VuiProgress
              value={(countOffLines / countAllUnits) * 100}
              color="error"
              label={false}
            />
          </div>

          <VuiBox display={"flex"} flexDirection={"column"} justifyContent={"flex-end"}>
            <VuiBox
              display={"flex"}
              flexDirection={"rows"}
              justifyContent={"flex-end"}
              alignItems={"center"}
            >
              <VerifiedIcon fontSize="medium" color="success" />
              <VuiOpenLink
                title={`Visualizar ${countOnLines} Relogios de Ponto${countOnLines > 1 ? "s" : ""} Online`}
                colorTitle={"success"}
                url="clocktimes?search=online"
              />
            </VuiBox>

            <VuiBox
              display={"flex"}
              flexDirection={"rows"}
              justifyContent={"flex-end"}
              alignItems={"center"}
            >
              {countOffLines > 0 ? (
                <>
                  <NotificationsActiveIcon fontSize="medium" color="error" />
                  <VuiOpenLink
                    title={`${countOffLines} Relogios de Ponto${
                      countOffLines > 1 ? "s" : ""
                    } Offine`}
                    colorTitle={"error"}
                    url="clocktimes?search=offline"
                  />
                </>
              ) : (
                <VuiLabel title={``} colorTitle="error" fontWeight="bold" sizeTitle={18} />
              )}
            </VuiBox>
          </VuiBox>
        </div>
      )}
    </>
  );
}

export default ClockTime;
